import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  container: {
    margin: "0",
    minHeight: "100vh",
  },
  leftCol: {
    padding: 0,
    backgroundColor: "white",
  },
  rightCol: {
    backgroundColor: "#FBF8F3",
    padding: 0,
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  rightContent: {
    height: "100%",
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  linePattern1Parent: {
    position: "absolute",
    top: -305,
    right: 2,
    zIndex: 1,
    "& svg": {
      color: "#FFAF4A",
    },
  },
  linePattern2Parent: {
    position: "absolute",
    bottom: -310,
    left: 0,
    zIndex: 1,
    "& svg": {
      color: "#FFF",
    },
  },
  invoiceImg: {
    width: "85%",
    height: "70%",
    objectFit: "fill",
    zIndex: 10,
  },
  leftContent: {
    padding: "20px 32px 96px 32px",
    height: "100%",
    width: "100%",
    "@media (max-width: 420px)": {
      padding: "20px 20px 96px 20px",
    },
  },

  contentWrapper: {
    flex: 1,
    width: "100%",
    maxWidth: 503,
  },

  emailIconBox: {
    width: 158,
    height: 158,
    borderRadius: "50%",
    borderTop: "1px solid #D4D4D4",
    background:
      "linear-gradient(180deg, #F1F1F1 0%, rgba(255, 255, 255, 0.00) 81.19%)",
    "& svg": {
      fontSize: 75,
      color: "#000000",
    },
  },

  loginBtn: {
    width: "100%",
    maxWidth: 262,
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
}));

export default useStyles;
